/*
  Sacrasoul - first-party Meta browser identity (_fbp / _fbc) + cart bridge.

  Extracted from snippets/meta-click-id-bootstrap.liquid on 2026-09-11. It was
  11,432 bytes of executable inline script in the <head> of every HTML document,
  re-sent uncompressed-per-document on every page view and compiled before the
  hero could paint. The snippet that loads it keeps only the stub that holds
  the visitorConsentCollected listener slot.

  Since 2026-10-05 nothing here waits on consent: the cookies are written when
  this deferred file runs, for every visitor, and a decline deletes nothing.
  Why, and how to restore the old gate, is the block at the foot of this file.
*/
(function () {
  var _metaBootstrapInitDone = false;

  /*
The cart read keeps the shopper's storefront: German, Czech and Dutch are path
prefixes on sacrasoul.com, and the drawer reads its cart from the same locale
root (CFG.cartUrl). Shopify.routes.root is that root, printed per request.

*/
  function cartJsUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return (root.charAt(root.length - 1) === '/' ? root : root + '/') + 'cart.js';
  }

  /*
One cart writer for Meta and first-party attribution. The boot shim queues
this until the full cart engine is ready; the engine serializes it with
quantity/add writes and rechecks the caller's guard at the wire boundary.
  
*/
  function writeMetaCartAttributes(attributes, guard) {
    function write() {
      var cart = window.SacrasoulCart;
      if (!cart || typeof cart.setAttributes !== 'function') return Promise.resolve(false);
      return Promise.resolve(cart.setAttributes(attributes, { guard: guard }))
        .then(function () { return true; }, function () { return false; });
    }
    if (document.readyState !== 'loading') return write();
    return new Promise(function (resolve) {
      document.addEventListener('DOMContentLoaded', function () { write().then(resolve); }, { once: true });
    });
  }

  function metaBootstrapInit() {
    if (_metaBootstrapInitDone) return;
    _metaBootstrapInitDone = true;
  try {
    var now = Date.now();
    var maxAge = 63072000;
    var expires = new Date(now + maxAge * 1000).toUTCString();
    var root = getRootDomain();

    function getCookie(name) {
      var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : '';
    }

    function setCookie(name, value, domain) {
      var cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAge + '; expires=' + expires + '; SameSite=Lax; Secure';
      if (domain) cookie += '; domain=' + domain;
      document.cookie = cookie;
    }

    function setFirstPartyCookie(name, value) {
      setCookie(name, value);
      if (root) setCookie(name, value, root);
    }

    function getRootDomain() {
      var host = location.hostname;
      var parts = host.split('.');
      if (parts.length < 2 || host === 'myshopify.com' || host.indexOf('.myshopify.com') === host.length - 14) return '';
      return '.' + parts.slice(-2).join('.');
    }

    /*
Identity cache: Cookie Keeper re-issues _fbp/_fbc as HttpOnly (~+4s),
which drops them from document.cookie. Mirror every write and every
successful cookie read into BOTH stores, and fall back to them when the
cookie is no longer script-readable. Keeper preserves the value, so the
cache stays correct.

localStorage, not sessionStorage alone: the takeover outlives the
session that caused it. Every later session starts with an empty
sessionStorage and an unreadable cookie, so a sessionStorage-only cache
mints a fresh _fbp that matches none of that visitor's other events —
and it is the cart bridge, i.e. the Purchase, that carries it. A
localStorage hit is written back into sessionStorage because web GTM's
1P cookie variable reads that key directly.

The persistent half carries the time its value was FIRST stored and dies
maxAge after it. A bound, not a mirror of the cookie: the cookie's expiry
is fixed at its own mint and Chrome truncates it to 400 days, so the two
never lapse together. The stamp is there so the copy has an end at all —
without it, one _fbp rides every Purchase for the life of the browser
profile. Re-reading the same value keeps the original stamp; re-stamping
on every read would slide the life forward one visit at a time and it
would never expire. Bare strings predate the stamp and are read as-is;
the session half stays bare, since it dies with the session regardless.
    
*/
    var CK_FBP = '_ss_fbp_cache';
    var CK_FBC = '_ss_fbc_cache';
    var CK_FBC_PENDING = '_ss_fbc_pending';

    function cachePut(key, value) {
      try { sessionStorage.setItem(key, value); } catch (e) {}
      var t = now;
      try {
        var prev = localStorage.getItem(key) || '';
        if (prev.charAt(0) === '{') {
          var was = JSON.parse(prev);
          if (was && was.v === value && typeof was.t === 'number') t = was.t;
        }
      } catch (e) {}
      try { localStorage.setItem(key, JSON.stringify({ v: value, t: t })); } catch (e) {}
    }

    function readIdent(name, cacheKey) {
      var v = getCookie(name);
      if (v) {
        cachePut(cacheKey, v);
        return v;
      }
      try { v = sessionStorage.getItem(cacheKey) || ''; } catch (e) { v = ''; }
      if (!v) {
        try { v = localStorage.getItem(cacheKey) || ''; } catch (e) { v = ''; }
        if (v.charAt(0) === '{') {
          var entry = null;
          try { entry = JSON.parse(v); } catch (e) {}
          v = (entry && typeof entry.v === 'string' && typeof entry.t === 'number' &&
               now - entry.t <= maxAge * 1000) ? entry.v : '';
          if (!v) { try { localStorage.removeItem(cacheKey); } catch (e) {} }
        }
        if (v) { try { sessionStorage.setItem(cacheKey, v); } catch (e) {} }
      }
      /*
Restore the cookie from a cache hit. The cookie is the only one of the
three copies the Stape SERVER container can see — it arrives in the
request header, where neither store does — and it is the shortest-lived:
ITP caps a script-set cookie at 7 days, Chrome at 400, and a
cookies-only clear takes it outright. The mint branch below is the sole
writer and a cache hit satisfies it, so without this the server and the
browser carry different identifiers from here on, permanently. A Cookie
Keeper re-issue is HttpOnly: getCookie cannot see it, but this setter
cannot overwrite it either, so that write is dropped and Keeper's value
stands.
      
*/
      if (v) setFirstPartyCookie(name, v);
      return v;
    }

    if (!readIdent('_fbp', CK_FBP)) {
      var fbpVal = 'fb.1.' + now + '.' + Math.floor(Math.random() * 2147483647);
      setFirstPartyCookie('_fbp', fbpVal);
      cachePut(CK_FBP, fbpVal);
    }

    var fbclid = new URLSearchParams(location.search).get('fbclid');
    var fbcCreated = now;
    /*
Promote a click ID buffered while the consent banner was pending. Nothing
writes this buffer since 2026-10-05 (init no longer waits for an answer);
the read stays so a session that spans the deploy keeps the click ID its
landing page stashed. The buffer has a 24h TTL, so after 2026-10-07 this
block only ever clears an empty key. Revalidated on read: sessionStorage can be
restored or altered, so the ID format, a finite past timestamp, and
the 24h TTL are all re-checked. The click capture time becomes the
_fbc creation time both cross-page and same-page, so a stale click
cannot dress as new and the stamp does not depend on which page the
shopper answered the banner on.
    
*/
    try {
      var pend = JSON.parse(sessionStorage.getItem(CK_FBC_PENDING) || 'null');
      if (pend && typeof pend.id === 'string' && pend.id.length <= 500 &&
          /^[\w.~%-]+$/.test(pend.id) &&
          typeof pend.t === 'number' && isFinite(pend.t) &&
          now - pend.t >= 0 && now - pend.t <= 86400000) {
        if (!fbclid) fbclid = pend.id;
        if (fbclid === pend.id) fbcCreated = pend.t;
      }
    } catch (e) {}
    try { sessionStorage.removeItem(CK_FBC_PENDING); } catch (e) {}
    if (fbclid) {
      var currentFbc = readIdent('_fbc', CK_FBC);
      if (!currentFbc || currentFbc.split('.').slice(3).join('.') !== fbclid) {
        var fbcVal = 'fb.1.' + fbcCreated + '.' + fbclid;
        setFirstPartyCookie('_fbc', fbcVal);
        cachePut(CK_FBC, fbcVal);
      }
    }

    /*
Cart attribute bridge: write _fbp/_fbc into the cart so they round-trip
back via orders/paid webhook note_attributes. Survives redirect-based
payments (BLIK, Apple Pay, Shop Pay) that bypass checkout pixel events.

Reads use the captured native fetch. Writes use SacrasoulCart's single
serialized gateway, so they cannot overlap quantity or attribution work.
One write per (cart token, cookie identity) is all attribution needs.
    
*/
    var SYNC_GATE = '_meta_cart_sync_v2';
    var nativeFetch = window.fetch ? window.fetch.bind(window) : null;

    function currentStamp() {
      return readIdent('_fbp', CK_FBP) + '|' + readIdent('_fbc', CK_FBC);
    }

    /* ONE SYNC IN THE AIR AT A TIME (2026-09-13). Every cart mutation schedules
       a sync, and an add is followed within a second by the attribution
       write, so two syncs used to overlap: both read a cart that did not yet
       carry _fbp (the first one's write was still queued behind the engine's
       serialized gateway) and both posted the same value. Measured live on
       /products/terracotta-burner, one add: /cart/update.js {_fbp} twice, each
       followed by the engine's /cart.js re-read -- two of the nine requests
       an add cost. A sync that finds one in flight now asks for one more run
       AFTER it settles, and that run reads the cart the write produced. */
    var _syncInFlight = null;
    var _syncAgain = false;

    function syncCartAttributes() {
      if (!nativeFetch) return;
      if (_syncInFlight) { _syncAgain = true; return; }
      var fbp = readIdent('_fbp', CK_FBP);
      var fbc = readIdent('_fbc', CK_FBC);
      if (!fbp && !fbc) return;
      var stamp = currentStamp();

      /*
Only write when the cart actually has line items — avoids creating
empty carts for every page view (which inflates abandoned-cart counts).
      
*/
      _syncInFlight = nativeFetch(cartJsUrl(), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart || !cart.item_count) return;
          var gate = stamp + '|' + cart.token;
          try {
            if (sessionStorage.getItem(SYNC_GATE) === gate) return;
          } catch (e) {}
          /*
cart already carries the same identifiers (fresh session,
previously-stamped cart) — record and skip the write
          
*/
          var existing = cart.attributes || {};
          if ((existing._fbp || '') === (fbp || '') && (existing._fbc || '') === (fbc || '')) {
            try { sessionStorage.setItem(SYNC_GATE, gate); } catch (e) {}
            return;
          }
          var attrs = {};
          if (fbp) attrs._fbp = fbp;
          if (fbc) attrs._fbc = fbc;
          return writeMetaCartAttributes(attrs, function () {
            return currentStamp() === stamp;
          }).then(function (ok) {
            if (ok) {
              try { sessionStorage.setItem(SYNC_GATE, gate); } catch (e) {}
            }
          });
        })
        .catch(function () {})
        .then(function () {
          _syncInFlight = null;
          if (_syncAgain) { _syncAgain = false; scheduleSync(); }
        });
    }

    /*
Coalesce mutation bursts (drawer ops fire add + change in quick
succession) into one sync check.
    
*/
    var _syncTimer = null;
    function scheduleSync() {
      if (_syncTimer) clearTimeout(_syncTimer);
      _syncTimer = setTimeout(function () {
        _syncTimer = null;
        syncCartAttributes();
      }, 300);
    }

    /*
Run once per page — catches existing carts. Still started from the shared
privacy resolver, though consent no longer decides anything here: it is the
moment this read has always happened (~2.5 s on a warm PL load), and keeping
it there means writing the cookies at defer adds no /cart.js request to the
window that decides LCP. Cart mutations are hooked below from defer, so a
cart built before the resolver answers is still synced.
    */
    Promise.resolve(window.SacrasoulPrivacyReady && window.SacrasoulPrivacyReady.ready).then(function () {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { syncCartAttributes(); });
      } else {
        syncCartAttributes();
      }
    });

    /*
Re-sync after any cart mutation (add / change / update / clear) so that
newly-created carts pick up the identifiers immediately, including in
Apple Pay / Shop Pay flows that build a cart on the fly. Our own sync
is fingerprinted, so a hook caused by its own successful write stops at
the next cart read instead of writing again.
    
*/
    var CART_MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

    var originalFetch = window.fetch;
    if (originalFetch) {
      window.fetch = function () {
        var args = arguments;
        var p = originalFetch.apply(window, args);
        try {
          var input = args[0];
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          if (CART_MUTATION_RE.test(url)) {
            p.then(scheduleSync, function () {});
          }
        } catch (e) {}
        return p;
      };
    }

    var originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (url && CART_MUTATION_RE.test(url)) {
          this.addEventListener('load', scheduleSync);
        }
      } catch (e) {}
      return originalOpen.apply(this, arguments);
    };
  } catch (e) {}
  }
  /*
NO CONSENT GATE (2026-10-05). Sho's decision record
sacrasoul-brain/strategy/decisions/2026-10-05-tracking-data-flows-regardless-of-consent-interim.md:
tracking data flows regardless of the visitor's consent choice while the
long-term approach is worked out. Server GTM v166 / web GTM v37 already send
the Meta browser-path events for everyone and the web pixel initialises for
everyone, so this file now matches them:

- _fbp is minted and _fbc is formed from a landing fbclid as soon as this
  deferred file runs, on every page, before any banner answer. Same cookie
  format, max-age and domains as before; only the gate is gone.
- A decline no longer expires _fbp/_fbc, drops the identity caches, strips the
  identifiers from the cart, or blocks the cart bridge.
- Our own traffic is excluded downstream by the ss_internal marker (server GTM
  trigger 305 and friends); this file never read it and still does not.

Until this change the file ran a three-state gate (grant / answered decline /
banner pending): init only on a grant, a pending fbclid buffered in
sessionStorage until the answer, and a decline that expired both cookies,
cleared both caches and POSTed {_fbp:'', _fbc:''} to the cart. To restore it,
revert the commit that introduced this block (it also reverts the matching
harness cases in scripts/tests/meta-click-id-bootstrap.harness.cjs and
scripts/tests/tag-boot-order.harness.cjs).

The listener slot in snippets/meta-click-id-bootstrap.liquid stays. With the
cookies written at defer it is no longer load-bearing, but keeping the stub and
the hook means the revert above is the whole rollback. The hook is idempotent:
init runs once per page.
  */
  window.__ssMetaOnConsent = function () { metaBootstrapInit(); };
  var queued = window.__ssMetaConsentQueue;
  if (queued && queued.length) queued.length = 0;

  metaBootstrapInit();
})();
